import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "propietarios",
    "propietario",
    "PropietarioForm",
    "/propietarios",
);

export default handleActions(reducers, initialState);
